import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SupplierJobScreenJob } from '../../../../interfaces/screen-specific/job-screen';
import { JobRejectionReasonDTO } from '../../../../interfaces/job-rejection/job-rejection-reason.dto.interface';
import { JobRejectionReasonService } from '../../../../services/job-rejection/job-rejection-reasons.service';
import { RejectJobWithReasonDTO } from '../../../../interfaces/job-rejection/reject-job-with-reason.dto.interface';
import {
  EventService,
  GoogleAnalyticsService,
  SupplierInboxJobsService,
  SupplierJobInteractionService,
} from '../../../../services';

@Component({
  selector: 'supplier-job-screen-reject-job',
  templateUrl: './supplier-job-screen-reject-job.component.html',
  styleUrls: ['./supplier-job-screen-reject-job.component.scss'],
})
export class SupplierJobScreenRejectJobComponent implements OnInit {
  @Input() rejectJobDialogVisible: boolean = false;
  @Output() rejectJobDialogVisibleChange = new EventEmitter<boolean>();
  @Input() job: SupplierJobScreenJob;

  public rejectReasons: JobRejectionReasonDTO[] = [];
  public rejectReason: JobRejectionReasonDTO = null;
  public rejectText: string = null;

  private googleAnalyticsEventCategory: string = 'supplier_jobs_inbox';
  private googleAnalyticsEventLabel: string = 'job_details';

  constructor(
    private jobRejectionReasonService: JobRejectionReasonService,
    private supplierJobInteractionService: SupplierJobInteractionService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private supplierInboxJobsService: SupplierInboxJobsService,
    private eventService: EventService,
  ) {}

  ngOnInit(): void {
    this.jobRejectionReasonService.getJobRejectionReasons().then((res) => {
      this.rejectReasons = res;
    });
  }

  rejectJob() {
    this.supplierJobInteractionService.logSingleJobInteraction('RejectJobAttempt', this.job.id, {});
    this.googleAnalyticsService.eventEmitter(
      'reject_job',
      this.googleAnalyticsEventCategory,
      'reject_job',
      this.googleAnalyticsEventLabel,
    );

    const dto = <RejectJobWithReasonDTO>{
      jobId: this.job.id,
      rejectionReasonId: this.rejectReason.id,
      reasonText: this.rejectText,
    };

    this.supplierInboxJobsService.rejectJobWithReason(dto).then(() => {
      this.rejectJobDialogVisible = false;
      this.supplierJobInteractionService.logSingleJobInteraction(
        'RejectJobSuccess',
        this.job.id,
        {},
      );
      this.eventService.JobScreenEvent.emit({
        event: 'job-rejected',
        data: { jobId: this.job.id },
        sender: 'rejectJobDialog',
      });
    });
    this.rejectReason = null;
  }

  cancelRejectJob() {
    this.rejectReason = null;
    this.rejectJobDialogVisible = false;
    this.rejectJobDialogVisibleChange.emit(false);
  }
}
